module.exports = __webpack_public_path__ + "static/media/25-5.237163fa.mp3";